import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { HelperService } from '../providers/helper/helper';
import { Api } from '../providers/providers';
import { MyApp } from './app.component';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

// Storage
import { AndroidFullScreen } from '@ionic-native/android-full-screen/ngx';
import { Deeplinks } from '@ionic-native/deeplinks/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Market } from '@ionic-native/market/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';

// IOnic Web View
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { EventLoggerProvider } from '../providers/event-logger/event-logger';
import { CustomTranslateLoader } from './custom-translate-loader';
import { ComponentsModule } from '../components/components.module';
import { IonicStorageModule } from '@ionic/storage';


@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    // BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      backButtonIcon: 'md-arrow-back',
      iconMode: 'md',
      mode: 'md'
    }),
    ComponentsModule,
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    Api,
    HelperService,
    StatusBar,
    SplashScreen,
    AndroidFullScreen,
    Deeplinks,
    AppVersion,
    Market,
    SocialSharing,
    WebView,
    // Keep this to enable Ionic's runtime error handling during development
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    EventLoggerProvider,
    Keyboard
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts